var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PageHeaderLayout',[_c('div',{staticClass:"main-page-content"},[_c('div',{staticClass:"theme-border default-padding",staticStyle:{"width":"900px","padding":"20px 30px"}},[_c('RobotSend',{ref:"refRobotSend"})],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }